// 音频管理器类
export class AudioManager {
    constructor() {
        this.bgm = null;
        this.isInitialized = false;
        this.isMuted = false;

        // 创建音乐控制按钮
        this.musicToggle = document.createElement('div');
        this.musicToggle.style.position = 'fixed';
        this.musicToggle.style.top = '140px';
        this.musicToggle.style.left = '20px';
        this.musicToggle.style.fontSize = '28px';
        this.musicToggle.style.color = '#fff';
        this.musicToggle.style.textShadow = '2px 2px 4px rgba(0,0,0,0.5)';
        this.musicToggle.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
        this.musicToggle.style.padding = '10px 20px';
        this.musicToggle.style.borderRadius = '10px';
        this.musicToggle.style.fontWeight = 'bold';
        this.musicToggle.style.cursor = 'pointer';
        this.updateMusicToggleText();

        // 添加点击事件
        this.musicToggle.addEventListener('click', () => this.toggleMusic());
        document.body.appendChild(this.musicToggle);
    }

    updateMusicToggleText() {
        this.musicToggle.textContent = this.isMuted ? '🔇 音乐: 关' : '🔊 音乐: 开';
    }

    async toggleMusic() {
        this.isMuted = !this.isMuted;
        if (!this.isInitialized) {
            await this.initializeAudio();
        }
        if (this.isMuted && this.bgm) {
            this.bgm.pause();
        } else if (this.bgm) {
            await this.bgm.play();
        }
        this.updateMusicToggleText();
    }

    async initializeAudio() {
        if (this.isInitialized) return;
        
        // 使用Scene中预加载的音频资源
        const scene = document.querySelector('canvas')?.sceneInstance;
        if (scene && scene.preloadedResources?.bgm) {
            this.bgm = scene.preloadedResources.bgm;
        } else {
            // 如果没有预加载的资源，则创建新的Audio对象
            this.bgm = new Audio();
            this.bgm.src = '/audio/bgm_sunny.mp3';
        }
        this.bgm.loop = true;
        this.isInitialized = true;
    }

    async playBGM() {
        try {
            if (!this.isInitialized) {
                await this.initializeAudio();
            }
            if (!this.isMuted && this.bgm) {
                await this.bgm.play();
            }
        } catch (error) {
            console.error('播放背景音乐失败:', error);
        }
    }

    pauseBGM() {
        this.bgm.pause();
    }

    dispose() {
        this.pauseBGM();
        if (this.musicToggle && this.musicToggle.parentNode) {
            this.musicToggle.parentNode.removeChild(this.musicToggle);
        }
    }
}

// 创建单例实例
export const audioManager = new AudioManager();